<template>
  <div class="login">
    
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      auto-complete="on"
      label-position="left"
    >
    <div class="loginTitle">波尼乐学校考勤系统</div>
      <div class="title-container">
        <h3 class="title">Login</h3>
      </div>
      <div class="detail-container">
        <el-form-item prop="mobile">
          <!-- <span class="svg-container">
            <svg-icon icon-class="user" />
          </span> -->
          <el-input
            ref="mobile"
            v-model="loginForm.mobile"
            placeholder="用户名"
            name="mobile"
            type="text"
            tabindex="1"
            auto-complete="on"
            prefix-icon="el-icon-user"
          />
        </el-form-item>

        <el-form-item prop="password">
          <!-- <span class="svg-container">
            <svg-icon icon-class="password" />
          </span> -->
          <el-input
            :key="passwordType"
            prefix-icon="el-icon-lock"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="密码"
            name="password"
            tabindex="2"
            auto-complete="on"
            show-password
            @keyup.enter.native="handleLogin"
          />
          <!-- <span class="show-pwd" @click="showPwd">
            <svg-icon
              :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"
            />
          </span> -->
        </el-form-item>
        <div class="resPwd">忘记密码</div>
        <el-button
          :loading="loading"
          type="primary"
          style="width: 100%; margin-bottom: 30px"
          @click.native.prevent="handleLogin"
        >
          登录
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import md5 from 'js-md5'
export default {
  name: 'Login',
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能少于6位'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        mobile: '',
        password: ''
      },
      loginRules: {
        mobile: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePassword }
        ]
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const formData = JSON.parse(JSON.stringify(this.loginForm))
          formData.password = md5(formData.password)
          this.$store
            .dispatch('user/login', formData)
            .then(() => {
              console.log('aaaa')
              this.$router.push({ path: '/' })
              this.loading = false
            })
            .catch(() => {
              console.log('bbbb')
              this.loading = false
            })
        }
      })
    }
  }
}
</script>


<style lang="scss">
/* 修复input 背景不协调 和光标变色 */

$bg:#e5e5e5;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login {
  background-image: url("../../assets/login_bg.jpg");
  background-position: right top;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-size: cover;
  background-origin: border-box;
  .el-input {
    display: inline-block;
    height: 47px;
    line-height: 47px;
    width: 100%;

    input {
      width: 100%;
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      // padding: 12px 5px 12px 15px;
      color: #666;
      height: 47px;
      caret-color: #666;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login {
  min-height: 100vh;
  width: 100%;
  // background-color: $bg;
  overflow: hidden;
  position: relative;

  

  .login-form {
    background: #fff;
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translateX(-50%);
    border-radius: 20px;
    width: 700px;
    max-width: 100%;
    padding: 120px 40px 70px 0px;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
  }
  .loginTitle{
    color: rgb(18, 56, 147);
    font-size: 40px;
    font-weight: bold;
    position: absolute;
    left: 50%;
    top: 20px;
    transform: translateX(-50%);
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;
    flex: 1;
    background-image: url("../../assets/login_logo.png");
    background-position: top center;
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-size: 68%;
    background-origin: border-box;
    .title {
      display: none;
      font-size: 26px;
      color: $light_gray;
      margin: 0 auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }
  .detail-container{
    flex: 1;
    padding: 20px 0;
  }

  .resPwd{
    font-size: 14px;
    text-align: right;
    margin-bottom: 15px;
    cursor: pointer;
    color: #444444;
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue